export const base64ToBlob = (base64Data) => {
  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: "application/octet-stream" });
};

export const handleDownload = async (base64Data, fileName) => {
  const blob = base64ToBlob(base64Data);

  const reader = new FileReader();
  reader.onloadend = () => {
    const array = new Uint8Array(reader.result);
    const header = array.reduce(
      (accumulator, byte) => accumulator + byte.toString(16).padStart(2, "0"),
      ""
    );
    // let extension = "";
    // const fileHeader = header.toLowerCase(); // Convert header to lowercase

    // if (fileHeader.startsWith("89504e47")) {
    //   // PNG
    //   extension = ".png";
    // } else if (fileHeader.startsWith("ffd8")) {
    //   // JPEG
    //   extension = ".jpg";
    // } else if (fileHeader.startsWith("25504446")) {
    //   // PDF
    //   extension = ".pdf";
    // } else if (fileHeader.startsWith("504b0304")) {
    //   // XLSX (ZIP-based format)
    //   extension = ".xlsx";
    // } else if (fileHeader.startsWith("d0cf11e0a1b11ae1")) {
    //   // XLS (Old Microsoft Excel format)
    //   extension = ".xls";
    // } else {
    //   // Default to generic extension
    //   extension = ".bin";
    // }

    const url = URL.createObjectURL(blob);

    // Create an anchor element
    const link = document.createElement("a");
    link.href = url;

    // Set the filename with appropriate extension
    link.setAttribute("download", fileName ? fileName : `download.bin`);

    // Trigger a click event to start the download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  reader.readAsArrayBuffer(blob);
};

export const TypeLabel = ({ type }) => {
  switch (type) {
    case "T":
      return "text";
    case "N":
      return "number";
    case "B":
      return "boolean";
    case "D":
      return "date";
    default:
      return "text";
  }
};

export const getExtenstion = (base64Data) => {
  const decodedString = atob(base64Data);

  if (decodedString.startsWith("%PDF-")) {
    return "pdf";
  }

  // Check if the decoded string starts with '\x89PNG' (indicative of a PNG image file)
  // or other common image file signatures
  if (
    decodedString.startsWith("\x89PNG") ||
    decodedString.startsWith("\xFF\xD8\xFF\xE0") ||
    decodedString.startsWith("\xFF\xD8\xFF\xDB")
  ) {
    return "image";
  }
};

export const downloadFile = (content, fileName) => {
  const blob = new Blob(
    [Uint8Array.from(atob(content), (c) => c.charCodeAt(0))],
    { type: "application/octet-stream" }
  );
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
